<template>
  <header class="navbar">
    <nav class="navbar__wrapper">
      <router-link :to="{ name: 'home' }" replace>
        <img class="navbar__ine-logo" src="@/assets/images/home-logo.png" />
      </router-link>
      <div :class="showMegaMenu ? 'navbar__menu-active' : ''">
        <button class="navbar__mega-menu-btn" @click="toggleMegaMenu()">
          Discover
          <i v-if="showMegaMenu" class="material-icons">arrow_drop_up</i>
          <i v-else class="material-icons">arrow_drop_down</i>
        </button>
      </div>
      <MegaMenu
        @closeMegaMenu="showMegaMenu = false"
        :showMenu="showMegaMenu"
      />
      <SearchForm class="navbar__search"></SearchForm>
      <UserProfile
        class="navbar__user-profile"
        :isAuthenticated="isAuthenticated"
        :profile="profile"
      ></UserProfile>
    </nav>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import SearchForm from '../../search/SearchForm.vue'
import MegaMenu from './mega-menu/MegaMenu.vue'
import UserProfile from './UserProfile.vue'

export default {
  name: 'NavBar',
  data() {
    return {
      showMegaMenu: false,
    }
  },
  components: {
    SearchForm,
    MegaMenu,
    UserProfile,
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      profile: 'auth/userProfile',
      userId: 'auth/userId',
    }),
  },
  methods: {
    toggleMegaMenu() {
      this.showMegaMenu = !this.showMegaMenu
    },
  },
  mounted() {
    const desktopNavBar = document.querySelector('.navbar__wrapper')
    const ineLogo = document.querySelector('.navbar__ine-logo')

    window.addEventListener('scroll', event => {
      event.preventDefault()

      if (window.scrollY >= 25) {
        desktopNavBar.classList.add('collapse-navbar')
        ineLogo.classList.add('collapse-logo')
      } else {
        desktopNavBar.classList.remove('collapse-navbar')
        ineLogo.classList.remove('collapse-logo')
      }
    })
  },
}
</script>

<style lang="scss" scoped>
.navbar {
  z-index: 202;
  background: transparent;
  transition: 0.5s all ease;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  &__wrapper {
    display: flex;
    align-items: center;
    position: relative;
    height: 100px;
    padding-left: 50px;
    padding-right: 15px;
    transition: 0.5s all ease;
    background: linear-gradient(
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0.1),
      transparent
    );
    @media screen and (max-width: 1024px) {
      padding: 0;
    }
  }
  &__ine-logo {
    height: 75px;
    transition: 0.5s all ease;
    @media screen and (max-width: 1024px) {
      height: 50px;
    }
  }
  &__mega-menu-btn {
    background-color: transparent;
    border: none;
    outline: none;
    color: var(--white);
    font-size: 1.3rem;
    transition: all 0.5s ease;
    font-weight: 400;
    padding: 30px;
    transition: 0.5s all ease;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  &__menu-active {
    background-color: var(--dark-gray) !important;
    transition: 0.5s all ease;
  }
  &__search {
    margin-left: auto;
  }
  &__user-profile {
    margin-left: 50px;
  }
  .collapse-navbar {
    background: rgba(0, 0, 0, 0.7) !important;
    height: 60px !important;
  }
  .collapse-logo {
    height: 50px !important;
  }
}
</style>
